<template>
<div id="ztfx">
    <header class="cur-head">
        <h1>{{stockName}}<span>{{stockCode}}</span><a :href="isWeixin ? 'http://android.myapp.com/myapp/detail.htm?apkName=com.android.dazhihui':'dzh_browser_url&goto=0&type=2970&code='+stockCode+'&kind=1'" class="fr">查看分时</a></h1>
        <p :class="{'font-red':updownRate>0,'font-green':updownRate<0}">{{stockPrice}}<span  v-html="updownRate=='--'?'--':updownRate+'%'"></span></p>
    </header>
    <nav class="nav">
        <span v-for="(item,index) in tabs" :class="{'cur':curTab==index}" @click="curTab=index,tabChange(index)">{{item}}</span>
    </nav>
    <section class="mod">
        <div class="chart-item">
            <p class="chart-tips">
                {{tabs[curTab]}}平均换手率
                <span :class="{'font-red':legend.pjhsl>0,'font-green':legend.pjhsl<0}" v-html="legend.pjhsl=='--'?'--':legend.pjhsl+'%'"></span>，涨停
                <span :class="{'font-red':legend.ztcs>0,'font-green':legend.ztcs<0}">{{legend.ztcs}}</span>次，涨停后第二个交易日最高涨幅
               <span :class="{'font-red':legend.crzf>0,'font-green':legend.crzf<0}" v-html="legend.crzf=='--'?'--':legend.crzf+'%'"></span>。
            </p>
            <div class="chart" style="height: 3.8rem;" id="kjtj-echart-container"><p class="blank">- 暂无数据 -</p></div>
        </div>
    </section>
    <section class="mod">
        <h2 class="mod-tit">
            涨停明细
            <span class="btn-switch" :class="{'block':wrapFlag}"  v-on:click="toggle"></span>
        </h2>
        <p class="blank" v-if="isBlank">- 暂无数据 -</p>
        <div class="table-wrap" v-show="!wrapFlag&&!isBlank">
            <div class="table-l">
                <div class="table-hd"><span>涨停日期</span></div>
                <ul class="table-bd">
                    <li v-for="item in list"><span v-if="item.ZhangTingRiQi != undefined && item.ZhangTingRiQi!=null">{{item.ZhangTingRiQi*1000 | dataFormat('yyyy-MM-dd')}}</span><span v-else>--</span></li>
                </ul>
            </div>
            <div class="table-r">
                <div class="table-r-scroll table-ztmx">
                    <div class="table-hd">
                        <span class="filter" :class="orders['ShouPanJia'] | orderClass(orderBy, 'ShouPanJia')"   @click="changeOrder('ShouPanJia')">收盘价</span>
                        <span class="filter" :class="orders['ZhangTingShiJian'] | orderClass(orderBy, 'ZhangTingShiJian')"   @click="changeOrder('ZhangTingShiJian')">涨停时间</span>
                        <span class="filter" :class="orders['CiRiZhangFu'] | orderClass(orderBy, 'CiRiZhangFu')"   @click="changeOrder('CiRiZhangFu')">次日涨幅</span>
                        <span class="filter" :class="orders['FengDanLiangZhanBi'] | orderClass(orderBy, 'FengDanLiangZhanBi')"   @click="changeOrder('FengDanLiangZhanBi')">封单占流通比</span>
                        <span class="filter" :class="orders['DangRiHuanShouLv'] | orderClass(orderBy, 'DangRiHuanShouLv')"   @click="changeOrder('DangRiHuanShouLv')">换手率</span>
                        <span class="filter" :class="orders['KaiBan'] | orderClass(orderBy, 'KaiBan')"   @click="changeOrder('KaiBan')">开板次数</span>
                        <span class="filter" :class="orders['ChengJiaoLiang'] | orderClass(orderBy, 'ChengJiaoLiang')"   @click="changeOrder('ChengJiaoLiang')">成交量</span>
                        <span class="filter" :class="orders['ChengJiaoJinE'] | orderClass(orderBy, 'ChengJiaoJinE')"   @click="changeOrder('ChengJiaoJinE')">成交金额</span>
                        <span class="filter" :class="orders['LianBan'] | orderClass(orderBy, 'LianBan')"   @click="changeOrder('LianBan')">连板</span>
                        <span v-if="showReason">涨停原因</span>
                    </div>
                    <ul class="table-bd">
                        <li v-for="item in list">
                            <span v-html="item.ShouPanJia==null?'--':item.ShouPanJia.toFixed(2)"></span>
                            <span v-if="item.ZhangTingShiJian!=null">{{item.ZhangTingShiJian*1000 | dataFormat('hh:mm')}}</span> <span v-else>--</span>
                            <span :class="{'font-red':item.CiRiZhangFu>0,'font-green':item.CiRiZhangFu<0}" v-html="item.CiRiZhangFu==null?'--':item.CiRiZhangFu.toFixed(2)+'%'"></span>
                            <span v-html="item.FengDanLiangZhanBi==null?'--':item.FengDanLiangZhanBi+'%'"></span>
                            <span v-html="item.DangRiHuanShouLv==null || item.DangRiHuanShouLv==undefined?'--':item.DangRiHuanShouLv+'%'"></span>
                            <span v-html="item.KaiBan==null?'--':item.KaiBan"></span>
                            <span>{{ item.ChengJiaoLiang | unitS}}</span>
                            <span>{{ item.ChengJiaoJinE| unitM}}</span>
                            <span v-html="item.LianBan==null?'--':item.LianBan"></span>
                            <span v-if="showReason" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :style="item.ZhangTingRiQi | reasonColor(reasons)" @click="showPop(item.ZhangTingRiQi)">{{item.ZhangTingRiQi | findReason(reasons)}}<small></small></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="pop-win" :class="{'show':popShow}">
            <p>{{reasons[curSelectDate] ? reasons[curSelectDate]:''}}</p>
            <a @click="popShow=false">知道了</a>
        </div>
        <div class="list-wrap" v-if="wrapFlag&&!isBlank">
            <div class="list-item" v-for="(item, index) in list">
                <h3 class="list-item-tit" v-if="item.ZhangTingRiQi != undefined && item.ZhangTingRiQi!=null">{{item.ZhangTingRiQi*1000 | dataFormat('yyyy-MM-dd')}}</h3><h3 class="list-item-tit" v-else>--</h3>
                <ul class="list-item-cont">
                    <li>收盘价<span v-html="item.ShouPanJia==null?'--':item.ShouPanJia.toFixed(2)"></span></li>
                    <li>成交量<span>{{ item.ChengJiaoLiang | unitS}}</span></li>
                    <li>换手率<span v-html="item.DangRiHuanShouLv==null || item.DangRiHuanShouLv==undefined?'--':item.DangRiHuanShouLv+'%'"></span></li>
                    <li>成交金额<span>{{ item.ChengJiaoJinE| unitM}}</span></li>
                    <li>涨停时间<span v-if="item.ZhangTingShiJian!=null">{{item.ZhangTingShiJian*1000 | dataFormat('hh:mm')}}</span> <span v-else>--</span></li>
                    <li>开板次数<span v-html="item.KaiBan==null?'--':item.KaiBan"></span></li>
                    <!--
                    <li>封单占流通比<span v-html="item.FengDanLiangZhanBi==null?'--':item.FengDanLiangZhanBi+'%'"></span></li>
                    -->
                    <li>封单占流通比<span v-html="item.FengDanLiangZhanBi==null?'--':((item.FengDanLiangZhanBi>=100000)?Math.round(item.FengDanLiangZhanBi):item.FengDanLiangZhanBi)+'%'"></span></li>
                    <li>连板<span v-html="item.LianBan==null?'--':item.LianBan"></span></li>
                    <li>次日涨幅<span :class="{'font-red':item.CiRiZhangFu>0,'font-green':item.CiRiZhangFu<0}" v-html="item.CiRiZhangFu==null?'--':item.CiRiZhangFu.toFixed(2)+'%'"></span></li>
                </ul>
                <div v-if="showReason" class="reason clearfix">涨停原因<div @click="showReasonMore(index)"><p :class="{'more':item.isMore}">{{item.ZhangTingRiQi | findReason(reasons)}}</p></div></div>
            </div>
        </div>
        <!-- 加载更多 -->
        <!--
        <p class="load-more" v-if="!isBlank"><span></span>上拉加载跟多</p>
        -->
        <div class="mod-help">数据于交易日收盘后更新</div>
        <a href="#/cal?DZHSPECIAL=1" class="link-text">查看全市场涨停分析</a>
    </section>
    <div class="banner" style="display: none" @click="downloadApp"><span>打开大智慧免费查看更多数据</span></div>
    <div class="footer">
        <p>【免责声明】本公司力求数据准确性，如有错漏请以证监会指定上市公司披露媒体为准。本公司不因对该资料产生或引起的任何损失承担任何责任。</p>
    </div>
</div>
</template>
<script>
import date from '@/utils/date.js'

import {share} from '@/utils/dzh'
import wxshare from '@/utils/wxshare'
import axios from 'axios'

export default {
	name: 'Index',
	data () {
		return {
            isWeixin:false,
            stockCode:'--',
            stockName:'',
            stockPrice:'--',
            updownRate:'--',
            tabs:['近一月','近三月','近半年','近一年'],
            curSelectDate: '',
            curTab:0,
            popShow:false,
            query: {type:'1month'},
            legend:{pjhsl:"--",ztcs:'--',crzf:'--'},
            chartData:{time:[], time2:[], spj:[],spj_min:0,spj_max:0,zt:[],zt_min:0,zt_max:0},
            charts: null,
            allTimestamps: [],
            klineData: [],
            limitupNodes: [],  //涨停红色散点
            minPrice: 9999,
            maxPrice: 0,
            latestNode: -1,  //离现在最近的涨停点
            wrapFlag:true,
            isBlank:false,
            isLoading:false,
            list:[],
            reasons: {}, //涨停原因
            showReason: true,
            waiting: false,
            orderBy: 'ZhangTingRiQi',
            orders: {ShouPanJia: 0,FengDanLiangZhanBi: 0,DangRiHuanShouLv: 0,ZhangTingShiJian: 0,KaiBan: 0,ChengJiaoLiang: 0,ChengJiaoJinE: 0,LianBan: 0,CiRiZhangFu: 0},
        }
	},
    filters:{
        orderClass: function (desc,orderKey, currentKey) {
            if(orderKey == currentKey) {
                if(desc == 1) {
                    return 'up';
                } else if(desc == -1) {
                    return 'down';
                }else{
                    return '';
                }
            } else {
                return '';
            }
        },
        unitS: function (num) {
            var moneyUnits = ["股","万","亿","万亿"]
            var dividend = 10000
            var curentNum = num //转换数字
            var curentUnit = moneyUnits[0] //转换单位
            for (var i = 0; i < 3; i++) {
                curentUnit = moneyUnits[i]
                var stringNum = curentNum.toString()
                var index = stringNum.indexOf(".")
                var newNum = stringNum
                if(index!=-1){ newNum = stringNum.substring(0,index) }

                if (newNum.length < 5) {
                    break;
                }
                curentNum = curentNum / dividend
            }
            var m = {num: 0, unit: ""}
            m.num = Number(curentNum).toFixed(2)
            m.unit = curentUnit
            return m.num + m.unit
        },
        unitM: function (num) {
            var moneyUnits = ["元","万", "亿", "万亿"]
            var dividend = 10000
            var curentNum = num //转换数字
            var curentUnit = moneyUnits[0] //转换单位
            for (var i = 0; i < 3; i++) {
                curentUnit = moneyUnits[i]
                var stringNum = curentNum.toString()
                var index = stringNum.indexOf(".")
                var newNum = stringNum
                if(index!=-1){ newNum = stringNum.substring(0,index) }

                if (newNum.length < 5) {
                    break;
                }
                curentNum = curentNum / dividend
            }
            var m = {num: 0, unit: ""}
            m.num = Number(curentNum).toFixed(2)
            m.unit = curentUnit
            return m.num + m.unit
        },
        dataFormat:function (value, fmt) {
            let getDate = new Date(value);
            let o = {
                'M+': getDate.getMonth() + 1,
                'd+': getDate.getDate(),
                'h+': getDate.getHours(),
                'm+': getDate.getMinutes(),
                's+': getDate.getSeconds(),
                'q+': Math.floor((getDate.getMonth() + 3) / 3),
                'S': getDate.getMilliseconds()
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                }
            }
            return fmt;
        },
        findReason:function (stamp, reasons) {
            let time = new Date(stamp*1000);
            var d = date.formt(new Date(time),"yyyyMMdd");
            if(reasons.hasOwnProperty(d)) {
                return reasons[d]
            } else {
                return '--'
            }
        },
        reasonColor:function (stamp, reasons) {
            let time = new Date(stamp*1000);
            var d = date.formt(new Date(time),"yyyyMMdd");
            if(reasons.hasOwnProperty(d)) {
                return 'color:#0e49d5'
            } else {
                return ''
            }
        }
    },
    created:function() {
        this.stockCode=this.$route.params.stockCode
        this.stockName=this.$route.params.stockName
        if (typeof(this.stockName) == "undefined") {
            this.stockName="";
            document.title    = this.stockCode+"-涨停分析";
        }else{
            document.title    = this.stockName+"-涨停分析";
        }
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            this.isWeixin= true;
        }else{
            this.isWeixin= false;
        }
        wxshare.do(this.$route.fullPath,'http://static.yundzh.com/logo.png',this.stockName+this.stockCode+"-大智慧涨停分析");
    },
	mounted:function(){
        this.getStkdataInfo();
        this.getLimitupStockanalysisInfo();
        this.getLimitupStockdataInfo();
        share(this.stockName+this.stockCode+"-大智慧涨停分析",this.$route.fullPath);
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            $('.banner').show();
        }
    },
    methods: {
        downloadApp:function() {
            window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.android.dazhihui'
        },
        showPop:function(stamp){
            let time = new Date(stamp*1000);
            var d = date.formt(new Date(time),"yyyyMMdd");
            if(this.reasons.hasOwnProperty(d)) {
                this.popShow = true;
                this.curSelectDate = d;
            }
        },
        showReasonMore:function(index) {
            this.$set(this.list[index], 'isMore', !this.list[index].isMore)
        },
        tabChange:function(index){
            if(this.waiting) {
                console.log('to fast');
                return false;
            }
            this.waiting = true;
            var self = this;
            setTimeout(function() {
                self.waiting = false;
            }, 300);
            this.minPrice = 9999
            this.maxPrice = 0
            this.klineData = []
            this.limitupNodes = []
            this.allTimestamps = []
            this.latestNode = -1
            this.curTab     = index;
            this.chartData  ={time:[], time2:[], spj:[],spj_min:0,spj_max:0,zt:[],zt_min:0,zt_max:0}
            switch(index)
            {
                case 0:
                    this.query.type='1month'
                    break;
                case 1:
                    this.query.type='3month'
                    break;
                case 2:
                    this.query.type='half'
                    break;
                case 3:
                    this.query.type='year'
                    break;
                default:
            }
            this.getLimitupStockanalysisInfo();
            this.getLimitupStockdataInfo();
        },
        chartTipFormatter:function(params) {
            var d = (params[0]!=undefined && params[0].name!=undefined)?this.chartData.time2[params[0].dataIndex]:"--";
            var a0 = (params[0]!=undefined && params[0].seriesName!=undefined)?params[0].seriesName:"--";
            var c0 = (params[0]!=undefined && params[0].data!=undefined)?params[0].data:"--";
            var a1 = (params[1]!=undefined && params[1].seriesName!=undefined)?params[1].seriesName:"--";
            var c1 = (params[1]!=undefined && params[1].data!=undefined)?params[1].data:"--";
            if(a1 == '--') {
                a1 = '个股收盘价';
            }
            if(d == undefined || d == null) {
                d = '--';
            }
            var tip = d
            if(params[2] != undefined && params[2].data != undefined && params[2].data != null) {
                tip += '<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#FF4500"></span>当日涨停'
            }
            tip += '<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#1E90FF"></span>'+a1+'：'+c1+
                '<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#ffc675"></span>'+a0+'：'+c0
            return tip
        },

        getStkdataInfo:function() {
            var _this=this;
            dzhyun.query('/stkdata', { obj:this.stockCode,field:'ZuiXinJia,ZhangFu,ZhongWenJianCheng'}, function(data) {
                //...
            }).then(function(data) {
                _this.handleGetStkdataSucc(data);
            }).catch(function(err) {
                //...
            });
        },
        handleGetStkdataSucc:function(res) {
            if(res.length>0 && res[0].ZhongWenJianCheng!=undefined) {
                this.stockCode   =res[0].Obj;
                this.stockName   =res[0].ZhongWenJianCheng;
                this.stockPrice  =(res[0].ZuiXinJia != undefined && res[0].ZuiXinJia !=null)?res[0].ZuiXinJia:"--";
                this.updownRate  =(res[0].ZhangFu != undefined && res[0].ZhangFu !=null)?res[0].ZhangFu:"--";
            }
        },
        getLimitupStockanalysisInfo:function() {
            var _this=this;
            dzhyun.query('/limitup/stockanalysis', { obj:this.stockCode,period:_this.query.type }, function(data) {
                //...
            }).then(function(data) {
                _this.handleGetLimitupStockanalysisSucc(data);
            }).catch(function(err) {
                //...
            });
        },
        handleGetLimitupStockanalysisSucc:function(res) {
            if(res.length>0){
                if(res[0].hasOwnProperty('ZhangTingKouJingTongJi')) {
                    this.legend.pjhsl   = (res[0].ZhangTingKouJingTongJi.PingJunHuanShouLv != undefined  && res[0].ZhangTingKouJingTongJi.PingJunHuanShouLv != null && res[0].ZhangTingKouJingTongJi.PingJunHuanShouLv != 0)?res[0].ZhangTingKouJingTongJi.PingJunHuanShouLv:"--";
                    this.legend.ztcs    = (res[0].ZhangTingKouJingTongJi.ZhangTingCiShu != undefined  && res[0].ZhangTingKouJingTongJi.ZhangTingCiShu != null && res[0].ZhangTingKouJingTongJi.ZhangTingCiShu != 0)?res[0].ZhangTingKouJingTongJi.ZhangTingCiShu:"--";
                    this.legend.crzf    = (res[0].ZhangTingKouJingTongJi.CiRiZhangFu != undefined  && res[0].ZhangTingKouJingTongJi.CiRiZhangFu != null && res[0].ZhangTingKouJingTongJi.CiRiZhangFu != 0)?res[0].ZhangTingKouJingTongJi.CiRiZhangFu:"--";
                } else {
                    this.legend.pjhsl = '--';
                    this.legend.ztcs = '--';
                    this.legend.crzf = '--';
                }
                for(var i=0;i<res[0].ZhangDieTingTongJi.length;i++) {
                    let time     =new Date(res[0].ZhangDieTingTongJi[i].RiQi*1000);
                    if(i==0) {
                        var begin_time = date.formt(new Date(time),"yyyyMMdd");
                    } else if(i==res[0].ZhangDieTingTongJi.length-1) {
                        //time     =new Date((res[0].ZhangDieTingTongJi[i].RiQi)*1000);
                        //time     =new Date((res[0].ZhangDieTingTongJi[i].RiQi+86400)*1000);
                        var end_time = date.formt(new Date((res[0].ZhangDieTingTongJi[i].RiQi+86400)*1000),"yyyyMMdd");
                    }
                    this.chartData.time[i]=date.formt(new Date(time),"MM/dd");
                    this.chartData.time2[i]=date.formt(new Date(time),"yyyy-MM-dd");
                    this.chartData.zt.push(res[0].ZhangDieTingTongJi[i].ZhangTing);
                    if(res[0].ZhangDieTingTongJi[i].ZhangTing > this.chartData.zt_max) {
                        this.chartData.zt_max = res[0].ZhangDieTingTongJi[i].ZhangTing;
                    }
                    this.allTimestamps.push(res[0].ZhangDieTingTongJi[i].RiQi)
                    if(res[0].ZhangTingShuJu !=undefined && res[0].ZhangTingShuJu.length>0){
                        res[0].ZhangTingShuJu.forEach(v=> {
                            if (v.ZhangTingRiQi != undefined && v.ZhangTingRiQi === res[0].ZhangDieTingTongJi[i].RiQi) {
                                this.chartData.spj[i] = v.ShouPanJia;
                                this.limitupNodes[i] = v.ShouPanJia
                                this.latestNode = i
                                if( v.ShouPanJia > this.chartData.spj_max) {
                                    this.chartData.spj_max = v.ShouPanJia;
                                }
                            }
                        })
                    }
                }
                var _this=this;
                dzhyun.query('/quote/kline', {obj:this.stockCode,split:1,period:'1day',start:1,begin_time:begin_time,end_time:end_time,field:'ShiJian,ShouPanJia'}, function(data) {
                    //...
                }).then(function(data) {
                    _this.handleGetKlineSucc(data);
                }).catch(function(err) {
                    //...
                });
            }else{
            }
        },
        getLimitUpReason: function(index){
            let self = this
            let url = window.Bk_Server+'/api/stock'
            let begin = this.chartData.time2[0]
            let end = this.chartData.time2[this.chartData.time2.length-1]
            let begin_date = begin.substring(0,4)+begin.substring(5,7)+begin.substring(8,10)
            let end_date = end.substring(0,4)+end.substring(5,7)+end.substring(8,10)
            axios.get(url,{
                params: {
                    stock_code: this.stockCode,
                    begin_date: begin_date,
                    end_date: end_date
                }
            }).then(response => {
                let res = response.data;
                if(res.error) {
                    return false;
                }
                if(res.Result.length === 0) {
                    self.showReason = false;
                    $('.table-ztmx').css('width', '16.8rem')
                } else {
                    self.showReason = true
                    $('.table-ztmx').css('width', '20.8rem')
                }
                res.Result.forEach(v => {
                    self.$set(self.reasons, v.date, v.upreason)
                })
            });
        },
        handleGetKlineSucc:function(res) {
            var start = 0
            if(res[0].Data!=undefined){
                for(var s=0;s<this.allTimestamps.length;s++) {
                    for(var i=0;i<res[0].Data.length;i++) {
                        if(res[0].Data[i].ShiJian == this.allTimestamps[s]) {
                            this.klineData[s] = res[0].Data[i].ShouPanJia
                            if(res[0].Data[i].ShouPanJia>this.maxPrice) {
                                this.maxPrice = res[0].Data[i].ShouPanJia
                            }
                            if(res[0].Data[i].ShouPanJia<this.minPrice) {
                                this.minPrice = res[0].Data[i].ShouPanJia
                            }
                            break
                        }
                    }
                }
            }
            this.getLimitUpReason()
            this.myChart()
        },
        myChart:function(){
            var _this = this;
            // 基于准备好的dom，初始化echarts实例
            var charts = echarts.init(document.getElementById('kjtj-echart-container'),'white');
            this.charts = charts
            // 指定图表的配置项和数据
            var option = {
                color:['#ffc675','#1E90FF'],
                title: {
                    //text: '近一月上证指数收盘价、大宗交易上榜个股只数与总成交额',
                    textStyle:{
                        fontSize:14,
                        color:'#191919'
                    },
                    left:'55',
                    top:0
                },
                legend:{
                    selectedMode:false,//取消图例上的点击事件,
                    tooltip:{
                        show:true
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter: '{b}<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#ffc675"></span>{a0}：{c0}<br/>'+
                    //         '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#1E90FF"></span>{a1}：{c1}<br/>'+
                    //         '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#FF4500"></span>该股涨停'
                    formatter:function(params){
                        return _this.chartTipFormatter(params)
                    },
                    // axisPointer: {
                    //     type: 'cross',
                    //     crossStyle: {
                    //         color: '#999'
                    //     }
                    // }
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '2%',
                    top:'30',
                    containLabel: true,
                    // show:true, //边框
                    borderWidth:1,
                },
                xAxis: {
                    type: 'category',
                    show:true,
                    boundaryGap: true,
                    splitLine:{
                        show:false
                    },
                    axisLine:{
                        lineStyle:{
                            color:'#c6c9cd',
                            width:1,
                            type:'solid',
                        }
                    },
                    axisLabel: {
                        interval: function(index,name){//index是x轴的坐标序号，name是坐标值
                            var timeLength=_this.chartData.time.length-1;
                            var interval
                            if(timeLength<=10){
                                if(index==0){
                                    return true;
                                }
                                if(index==timeLength){
                                    return true;
                                }
                            }else if(timeLength<=30){
                                interval=Math.ceil(timeLength/2)
                                if(index==interval*0){
                                    return true;
                                }
                                if(index==interval*1){
                                    return true;
                                }
                                if(index==timeLength){
                                    return true;
                                }
                            }else{
                                interval=Math.ceil(timeLength/4)
                                if(index==interval*0){
                                    return true;
                                }
                                if(index==interval*1){
                                    return true;
                                }
                                if(index==interval*2){
                                    return true;
                                }
                                if(index==interval*3){
                                    return true;
                                }
                                if(index==timeLength){
                                    return true;
                                }
                            }
                        },
                        textStyle: {
                            color:'#7f7f7f',
                        },
                        formatter: null
                    },
                    axisTick:{
                        interval:0,
                        alignWithLabel:true
                    },
                    nameLocation:'middle',
                    data: _this.chartData.time
                },
                yAxis: [
                    {
                        // name: '元',
                        nameTextStyle:{
                            color:'#7f7f7f'
                        },
                        type: 'value',
                        nameLocation: 'end',
                        min: Math.floor(_this.minPrice*0.95),//动态
                        max: Math.ceil(_this.maxPrice*1.05),//动态
                        axisLine:{
                            lineStyle:{
                                color:'#c6c9cd',
                                width:1,
                                type:'solid'
                            }
                        },
                        axisLabel:{
                            textStyle:{
                                color:'#7f7f7f'
                            }
                        },
                        splitLine:{
                            show:false
                        }
                        //nameGap:26,
                    },
                    {
                        //  name: '只',
                        nameTextStyle:{
                            color:'#7f7f7f'
                        },
                        type: 'value',
                        nameLocation: 'end',
                        min:0,//动态
                        max:Math.ceil(_this.chartData.zt_max*1.15),//动态
                        axisLine:{
                            lineStyle:{
                                color:'#c6c9cd',
                                width:1,
                                type:'solid'
                            }
                        },
                        axisLabel:{
                            textStyle:{
                                color:'#7f7f7f'
                            }
                        },
                        splitLine:{
                            show:false
                        }
                        //nameGap:26,
                    }
                ],
                series: [
                    {
                        name:'全市场涨停家数',
                        type:'line',
                        yAxisIndex:1,
                        itemStyle : {
                            normal : {
                                lineStyle:{
                                    color:'#ffc675'
                                }
                            }
                        },
                        data:this.chartData.zt
                    },
                    {
                        symbol: "none",
                        name:'个股收盘价',
                        type:'line',
                        itemStyle : {
                            normal : {
                                lineStyle:{
                                    color:'#1E90FF'
                                }
                            }
                        },
                        data:this.klineData,
                        connectNulls:true
                    },
                    {
                        name:'当日涨停',
                        type:'scatter',
                        itemStyle : {
                            normal : {
                                color:'#FF4500'
                            }
                        },
                        data:this.limitupNodes,
                    }
                ]
            };
            charts.setOption(option);
            this.waiting = false;
            if(this.latestNode > -1) {
                setTimeout(function () {
                    _this.charts.dispatchAction({
                        type: 'showTip',
                        seriesIndex:0 ,//第几条series
                        dataIndex: _this.latestNode,//第几个tooltip
                    });
                },800);
            }
        },
        toggle: function () {
            this.wrapFlag =! this.wrapFlag;
        },
        changeOrder: function (currentKey) {
            this.orderBy = currentKey;
            let status;
            if(this.orders[currentKey]==0){
                status=-1
            }
            if(this.orders[currentKey]==1){
                status=0;
            }
            if(this.orders[currentKey]==-1){
                status=1;
            }
            if(status == 1) {
                this.sort(currentKey,1);
            } else if(status == -1) {
                this.sort(currentKey,-1);
            }else{
                this.sort("ZhangTingRiQi",-1);
            }
            this.orders[currentKey]=status;
        },
        sort(key,desc){
            let arrOne=[]
            let arrTwo=[];
            this.list.forEach(v=> {
                if(v[key]==undefined && v[key]==null){
                    arrTwo.push(v)
                }else{
                    arrOne.push(v)
                }
            })
            if(desc==1){
                arrOne.sort(function(a,b){
                    var x = parseFloat(a[key]);
                    var y = parseFloat(b[key]);
                    return x - y;
                })
            }else{
                arrOne.sort(function(a,b){
                    var x = parseFloat(a[key]);
                    var y = parseFloat(b[key]);
                    return y - x;
                })
            }
            this.list=arrOne.concat(arrTwo);
        },
        getLimitupStockdataInfo:function() {
            var _this=this;
            dzhyun.query('/limitup/stockdata', { obj:this.stockCode,orderby:'ztrq',desc:true,start:0,period:this.query.type }, function(data) {
                //...
            }).then(function(data) {
                _this.handleGettLimitupStockdataSucc(data);
            }).catch(function(err) {
                //...
            });
        },
        handleGettLimitupStockdataSucc:function(res) {
            if(res.length>0 && res[0].ZhangTingShuJu != undefined && res[0].ZhangTingShuJu.length>0){
                //this.list        = this.list.concat(res[0].ZhangTingShuJu);
                this.list        = res[0].ZhangTingShuJu;
                for(let i=0;i<this.length;i++) {
                    this.$set(this.list[i], 'isMore', false);
                }
                this.isBlank=false;
            }else{
                this.isBlank=true;
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Index.vue